import { gql } from 'apollo-boost';

const GET_CV_COMPANIES = gql`
  query {
    getCVCompanies {
      id
      name
      internName
      internCode
    }
  }
`;

const GET_COMPANY_PORTAL_DATA = gql`
  query ($alias: String!) {
    getCompanyPortalData(alias: $alias) {
      id
      logo
      name
      portalType
    }
  }
`;

const GET_STATES_OF_COMPANY = gql`
  query ($companyId: ID!) {
    getCompanyStates(companyId: $companyId) {
      state {
        id
        name
      }
    }
  }
`;

const ADD_OR_UPDATE_CER_FILES = gql`
  mutation (
    $cerType: String!
    $cerBase64: String!
    $keyBase64: String!
    $keyPass: String!
    $rfc: String!
  ) {
    addOrUpdateCerFiles(
      cerType: $cerType
      cerBase64: $cerBase64
      keyBase64: $keyBase64
      keyPass: $keyPass
      rfc: $rfc
    )
  }
`;

export {
  GET_CV_COMPANIES,
  GET_COMPANY_PORTAL_DATA,
  GET_STATES_OF_COMPANY,
  ADD_OR_UPDATE_CER_FILES,
};
